export const supportedContentLocales = ["en", "ja"] as const
export const contentStatuses = ["draft", "published", "archived"] as const

export const contentTypeNames = [
  "news",
  "careers",
  "workProducts",
  "workMarketing",
  "workTags",
  "companyHistory",
  // PLAYDATA microsite. Prefixed rather than reusing "news" because this union
  // is shared across both sites, and the prefix is what keeps the two archives
  // apart in the database, the permission strings and the dashboard routes.
  "playdataNews",
  // The microsite's two legal documents. One record per locale each, so they
  // are singletons rather than a collection — see `singleton` in definitions.
  "playdataTerms",
  "playdataPrivacy",
  // Microsite settings: one record per locale, holding the sample report link.
  "playdataSettings",
] as const

export type ContentLocale = (typeof supportedContentLocales)[number]
export type ContentStatus = (typeof contentStatuses)[number]
export type ContentTypeName = (typeof contentTypeNames)[number]
export const supportedLocales = supportedContentLocales
export type SupportedLocale = ContentLocale

export type CmsJsonValue = string | number | boolean | null | CmsJsonValue[] | { [key: string]: CmsJsonValue }
export type CmsRecordValues = { [key: string]: CmsJsonValue }

export type CmsRecordSummary = {
  id: string
  contentItemId: string
  type: ContentTypeName
  status: ContentStatus
  language: ContentLocale
  slug: string | null
  title: string | null
  updatedAt: string
  publishedAt: string | null
  revision: number
  values?: CmsRecordValues
}

export type CmsRecordDetail = CmsRecordSummary & {
  values: CmsRecordValues
}

export type CmsRecordListPage = {
  items: CmsRecordSummary[]
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export type ContentDocumentSummary = CmsRecordSummary
export type ContentDocumentDetail = CmsRecordDetail
export type ContentDocumentListPage = CmsRecordListPage
export type JsonObject = CmsRecordValues
export type JsonValue = CmsJsonValue

export type CareerTeamOption = {
  key: string
  name: string
}

export type ContentSlug = { current?: string }

export type ContentAsset = {
  id?: string
  objectKey?: string
  url?: string
  mimeType?: string
  altText?: string
  title?: string
  tags?: string[]
  width?: number
  height?: number
}

export type ContentImage = {
  asset?: ContentAsset
}
